import React from 'react';
import classes from './footer.module.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.footer}>
      <p>
        {t('Copyright')}
        {' © 2020 FuturePlusPlus Enterprises Ltd.  '}
        {t('All Right Reserved')}
        {/* <a href={'ditsay.com'} style={{ color: 'white' }}>
            User terms and Privacy policy
          </a> */}
      </p>
    </div>
  );
};

export default Footer;
